import { useRef, useState } from 'react'

export type Press = () => void | Promise<unknown>

/** Press guard for every action control: a pending promise keeps the control
 *  busy and ignores further presses, so a command is never sent twice. */
export function usePress(onPress: Press | undefined, blocked = false, forcedBusy = false) {
  const [pending, setPending] = useState(false)
  const lock = useRef(false)
  const busy = forcedBusy || pending
  const disabled = blocked || busy || !onPress
  const press = () => {
    if (disabled || lock.current) return
    const result = onPress?.()
    if (result && typeof (result as Promise<unknown>).then === 'function') {
      lock.current = true
      setPending(true)
      ;(result as Promise<unknown>).finally(() => {
        lock.current = false
        setPending(false)
      })
    }
  }
  return { busy, disabled, press }
}
